export { default as MainPostSection } from './main-post-section';
